export default __webpack_public_path__ + "static/media/mail.cc8fd7bf.svg";